type SuccessCallback = (json: any) => void
type ErrorCallback = (code: number) => void

export function getLiveFeed(galleryCode: string, handleSuccess: SuccessCallback, handleError: ErrorCallback) {
  let params = new URLSearchParams()
  params.append("number", "25")
  params.append("offset", "0")
  params.append("sort", "newest")

  fetchGet(process.env.REACT_APP_API_BASE_URL + "/gallery/" + galleryCode + "/json?" + params.toString(), handleSuccess, handleError)
}

export function resolveInitialFetchLink(galleryCode: string, quantity: number): string {
  let params = new URLSearchParams()
  params.append("number", quantity.toString())
  params.append("offset", "0")
  params.append("sort", "newest")
  return process.env.REACT_APP_API_BASE_URL + "/gallery/" + galleryCode + "/json?" + params.toString()
}

function fetchGet(url: string, handleSuccess: SuccessCallback, handleError: ErrorCallback) {
  fetch(url, { method: "get" })
    .then(response => {
      if (!response.ok) {
        handleError(response.status)
        return
      }
      return response.json();
    })
    .then(json => {
      if (!json.id && !json.success) {
        handleError(404)
        return
      }

      handleSuccess(json)
    }).catch(data => {
      handleError(data.status);
    });
}

export function fetchNextUploads(link: string, handleSuccess: SuccessCallback, handleError: ErrorCallback) {
  fetchGet(link, handleSuccess, handleError)
}
